import { useSearchParams } from 'react-router-dom';
/**
 * URL 특정 param을 탐색하고 값을 가져오는 hook
 * @param {string} target - target param
 */
function useSearchParam(target = '') {
  const [searchParam] = useSearchParams();
  const param = searchParam.get(target) ?? '';
  return { param };
}

export default useSearchParam;
